import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BatteryAlertIcon(props: IconProps) {
    return <Icon {...props} iconKey={"battery_alert"}/>
}
